/**
 * Reporting buckets. Report components address these, never raw ledger lines,
 * so ERP chart-of-accounts differences are absorbed by the bucket mapping.
 */
export enum ReportingBucket {
  REVENUE = 'REVENUE',
  COST_OF_GOODS_SOLD = 'COST_OF_GOODS_SOLD',
  OPEX_PAYROLL = 'OPEX_PAYROLL',
  OPEX_RENT_FACILITIES = 'OPEX_RENT_FACILITIES',
  OPEX_PROFESSIONAL_SERVICES = 'OPEX_PROFESSIONAL_SERVICES',
  OPEX_SOFTWARE = 'OPEX_SOFTWARE',
  OPEX_MARKETING = 'OPEX_MARKETING',
  OPEX_TRAVEL = 'OPEX_TRAVEL',
  OPEX_OTHER = 'OPEX_OTHER',
  DEPRECIATION_AMORTISATION = 'DEPRECIATION_AMORTISATION',
  NON_OPERATING_INCOME = 'NON_OPERATING_INCOME',
  NON_OPERATING_EXPENSE = 'NON_OPERATING_EXPENSE',
  INCOME_TAX = 'INCOME_TAX',
  CASH = 'CASH',
  INVESTMENTS = 'INVESTMENTS',
  ACCOUNTS_RECEIVABLE = 'ACCOUNTS_RECEIVABLE',
  INVENTORY = 'INVENTORY',
  OTHER_CURRENT_ASSETS = 'OTHER_CURRENT_ASSETS',
  FIXED_ASSETS = 'FIXED_ASSETS',
  OTHER_NON_CURRENT_ASSETS = 'OTHER_NON_CURRENT_ASSETS',
  ACCOUNTS_PAYABLE = 'ACCOUNTS_PAYABLE',
  DEBT = 'DEBT',
  OTHER_CURRENT_LIABILITIES = 'OTHER_CURRENT_LIABILITIES',
  OTHER_NON_CURRENT_LIABILITIES = 'OTHER_NON_CURRENT_LIABILITIES',
  SHARE_CAPITAL = 'SHARE_CAPITAL',
  RETAINED_EARNINGS = 'RETAINED_EARNINGS',
  OTHER_EQUITY = 'OTHER_EQUITY',
  EXCLUDED = 'EXCLUDED',
}

export type LedgerStatement = 'PNL' | 'BS';

export type IncomeStatementSection =
  | 'revenue'
  | 'cost_of_goods_sold'
  | 'operating_expenses'
  | 'non_operating_revenue'
  | 'non_operating_expenses';

export type BalanceSheetSection = 'assets' | 'liabilities' | 'equity';

export type LedgerSection = IncomeStatementSection | BalanceSheetSection;

/** A leaf line of the P&L or balance sheet, keyed by a stable id derived from its statement path. */
export interface ILedgerLine {
  id: string;
  name: string;
  statement: LedgerStatement;
  section: LedgerSection;
  /** Ancestor section names from the statement root down to (excluding) the leaf. */
  path: string[];
}

export type BucketOverrides = Record<string, ReportingBucket>;

export type BucketMap = Map<string, ReportingBucket>;

export type BucketTotals = Record<ReportingBucket, number>;
